import { render, staticRenderFns } from "./Railway_Component.vue?vue&type=template&id=4f873c2d&scoped=true&"
import script from "./Railway_Component.vue?vue&type=script&lang=js&"
export * from "./Railway_Component.vue?vue&type=script&lang=js&"
import style0 from "./Railway_Component.vue?vue&type=style&index=0&id=4f873c2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f873c2d",
  null
  
)

export default component.exports